export default "__VITE_ASSET__L$AU7U$O__"